import { Heart } from "lucide-react";
import { Link } from "react-router-dom";
import { APP_VERSION, getFormattedBuildDate } from "@/lib/version";
import { cn } from "@/lib/utils";

interface AppFooterProps {
  compact?: boolean;
  className?: string;
}

export function AppFooter({ compact = false, className }: AppFooterProps) {
  return (
    <div className={cn("text-center text-sm text-muted-foreground space-y-1", className)}>
      {!compact && (
        <Link 
          to="/app-info" 
          className="text-xs hover:text-foreground transition-colors inline-block"
        >
          v{APP_VERSION} • {getFormattedBuildDate()}
        </Link>
      )}
      <p className="flex items-center justify-center gap-1.5 flex-wrap font-medium">
        <span>Built With Love</span>
        <Heart className="h-3 w-3 text-red-500 fill-red-500" />
        <span>By Pure Aura Technologies Pvt. Ltd.</span>
      </p>
    </div>
  );
}
